<template>
  <section v-if="enabled" class="preset-artifact-tasks" aria-label="会话文档任务">
    <div v-if="jobs.length" class="preset-artifact-heading">
      <strong>会话文档任务</strong>
      <el-button size="mini" type="text" @click="reload">刷新任务</el-button>
    </div>
    <agent-artifact-task-card v-for="job in jobs" :key="job.jobId" :job="job"
      @review="openReview" @files="showFiles" @analysis="showAnalysis" />
    <!-- 复用内部智能体的双 Gate、预览和私有下载实现；预设场景不额外开放手工创建。 -->
    <agent-artifact-panel ref="panel" :session-guid="sessionGuid" runtime-engine="mastra"
      entry-mode="chat" @jobs-change="onJobsChange" />
  </section>
</template>

<script>
import AgentArtifactPanel from '@/views/app/layout-agent/components/agent-artifact-panel.vue'
import AgentArtifactTaskCard from '@/views/app/layout-agent/components/agent-artifact-task-card.vue'
import { presetArtifactSignal } from '@/utils/preset-artifact-tasks.mjs'

export default {
  name: 'preset-artifact-tasks',
  components: { AgentArtifactPanel, AgentArtifactTaskCard },
  props: {
    sessionGuid: { type: String, default: '' },
    runtimeEngine: { type: String, default: '' },
    artifactJob: { type: Object, default: null }
  },
  data() { return { jobs: [] } },
  computed: {
    enabled() {
      return Boolean(this.sessionGuid && (this.runtimeEngine === 'mastra'
        || presetArtifactSignal(this.artifactJob, this.sessionGuid)))
    }
  },
  watch: {
    artifactJob: {
      immediate: true,
      handler(job) {
        const signal = presetArtifactSignal(job, this.sessionGuid)
        if (!signal) return
        // 第一条文档事件可能早于轮次列表刷新；等真实 Mastra 任务面板挂载再同步。
        this.$nextTick(() => {
          if (signal.sessionGuid === this.sessionGuid) this.$refs.panel?.trackJob(signal)
        })
      }
    }
  },
  methods: {
    onJobsChange(result) {
      if (result?.sessionGuid !== this.sessionGuid) return
      this.jobs = (Array.isArray(result.jobs) ? result.jobs : [])
        .filter(job => job.sessionGuid === this.sessionGuid)
    },
    openReview(job) { this.$refs.panel?.openReview(job) },
    showFiles(job) { this.$refs.panel?.showFiles(job) },
    showAnalysis(job) { this.$refs.panel?.showAnalysis(job) },
    reload() { this.$refs.panel?.loadJobs() }
  }
}
</script>

<style scoped>
.preset-artifact-tasks { margin: 12px 44px; }
.preset-artifact-heading { display: flex; align-items: center; gap: 12px; font-size: 13px; }
</style>
